export default "__VITE_ASSET__UXLjh5rv__"